export const drawerWidth = 260;
export const drawerClosedWidth = 50;
export const addEditDrawerWidth = 350;

export const actionColumns = ['actions'];
export const pageSizes = [10, 20, 50];
export const filteringStateColumnExtensions = [
  { columnName: 'actions', filteringEnabled: false },
];

export const stockAvailability = { 'available': 'AVAILABLE', 'unavailable': 'UNAVAILABLE' };
export const transportOrderState = { 'moving': 'MOVING', 'done': 'DONE', 'stopped': 'STOPPED' };

//number of colums on the orders overview page => 12/12 => 1 colum , 6/12 => 2, 4/12 => 3 , 3/12 => 4, ...
export const xsValue = 6 // 1 colum

export const defaultAuthenticationErrorMessage = "The username and password do not match"
export const loginUserName = "demo"
export const loginPassWord = "demo"

//Product type
export const productTypePackaging = 'Packaging'
export const productTypeAdditive = 'Additive'
export const productTypeRawMaterial = 'RawMaterial'
export const tapeFoil = 'TapeFoil'
export const productTypeLight = 'Light'
export const productTypeBattery = 'Battery'
export const productTypeCase = 'Case'

export const flashlightColors = ["Black", "Grey", "Blue", "No preference"]
export const flashlightLengths = ["Short", "Long"]

export const uomPieces = "pieces"

export const closeFinishRushOrderDialogTimeout = 300000

// NotificationTypes
export const severityTypes = { 'WARNING': 2, 'ERROR': 3 }

